import { FormControl, FormGroup } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnackbarService } from './../../../services/snackbar.service';
import { IBeneficiaryType } from './../../../models/contract';
import { ApiBeneficiaryService } from './../../../services/api/api-beneficiary.service';
import { IContractInput, IContractInputsForm } from 'src/app/models/contract';
import { BeneficiarioBaseInputs } from 'src/app/shared/utils/base';
import { IBeneficiaryFormDialogData } from 'src/app/models/dialog';

@Component({
  selector: 'app-contrato-beneficiario-form',
  templateUrl: './contrato-beneficiario-form.component.html',
  styleUrls: ['./contrato-beneficiario-form.component.scss']
})
export class ContratoBeneficiarioFormComponent implements OnInit {
  tabTitle = '';

  form!: FormGroup<IContractInputsForm>;

  inputControllerResolver: IContractInput[] = [];

  inputs = BeneficiarioBaseInputs.inputs;

  editableFields: string[] = [];
  beneficiaryTypes: IBeneficiaryType[] = [];

  constructor(
    private _dialogRef: MatDialogRef<ContratoBeneficiarioFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IBeneficiaryFormDialogData,
    private _beneficiaryService: ApiBeneficiaryService,
    private _snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this.getBeneficiaryTypes();

    if (this.data?.form) {
      if (
        this.data.form.controls['BeneficiaryType']?.value?.toLowerCase() ===
          'subsidiaria' ||
        !this.data.form.controls['BeneficiaryTypeId']?.value
      ) {
        this.editableFields = [];
      } else {
        this.editableFields = ['Document', 'Fee'];
      }
    } else {
      this.editableFields = ['Name', 'Document', 'Fee', 'BeneficiaryTypeId'];
    }

    this.buildForm();
    this.listeningEvents();
  }

  listeningEvents(): void {
    if (this.form.controls['BeneficiaryTypeId']) {
      this.form.controls['BeneficiaryTypeId'].valueChanges.subscribe({
        next: (response) => {
          this.setBeneficiaryName(response as string);
        }
      });
    }
  }

  getBeneficiaryTypes(): void {
    this._beneficiaryService.getBeneficiaryType().subscribe({
      next: (response) => {
        this.beneficiaryTypes = response.Data ?? [];
      }
    });
  }

  setBeneficiaryName(hashId: string): void {
    let name: string =
      this.beneficiaryTypes.find((bn) => bn.BeneficiaryTypeId === hashId)
        ?.Name ?? '';

    this.form.controls['BeneficiaryType'].setValue(name);
  }

  buildForm(): void {
    if (this.data.form) {
      this.form = this.data.form;
    } else {
      const controls = {} as IContractInputsForm;

      this.inputs.forEach((el) => {
        if (el.controlName) {
          controls[el.controlName] = new FormControl(null);
        }
      });

      this.form = new FormGroup<IContractInputsForm>(controls);
    }

    if (!this.editableFields.includes('BeneficiaryTypeId'))
      this.form.controls['BeneficiaryTypeId']?.disable();
  }

  close(action: boolean): void {
    let form = null;

    let validForm: boolean = this.formValidator();

    if (action && !validForm) {
      this._snackbarService.openSnackBar(
        'Beneficiário deve ser preenchido corretamente!',
        'warning'
      );
      return;
    }

    if (action) {
      form = this.form.getRawValue();
      form['Fee'] = Number(form['Fee']);
      if (this.data?.contractId) form['ContractId'] = this.data.contractId;
    }

    this._dialogRef.close(form);
  }

  formValidator(): boolean {
    return (
      !!this.form.controls['Document']?.value &&
      !!this.form.controls['Name']?.value &&
      !!this.form.controls['Fee']?.value &&
      !!this.form.controls['BeneficiaryTypeId']?.value
    );
  }
}
